import request from '@/utils/request3'
import store from '@/store'
const serviceName = store.state.serviceName.goodsSystem

// 获取所有的商机项目
export function getAllProject(data) {
    return request({
        url: serviceName + `/purchase/query_all_project`,
        method: 'get',
        data: data
    })
}

// 获取采购单列表
export function getPurchaseList(data) {
    return request({
        url: serviceName + `/purchase/query_purchaseList_byPage`,
        method: 'post',
        data: data
    })
}

// 新增采购单
export function addPurchaseList(data) {
    return request({
        url: serviceName + `/purchase/insert_purchaseList`,
        method: 'post',
        data: data
    })
}

// 根据采购单号查询采购货物
export function queryPurchaseGoodList(data) {
    return request({
        url: serviceName + `/purchase/query_purchaseGoodList?purchaseNo=` + data.purchaseNo,
        method: 'get',
        data: data
    })
}

// 修改采购单
export function updatePurchaseGoodList(data) {
    return request({
        url: serviceName + `/purchase/update_purchaseList`,
        method: 'post',
        data: data
    })
}

// 删除采购单
export function deletePurchaseGoodList(data) {
    return request({
        url: serviceName + `/purchase/delete_purchaseList?id=` + data.id,
        method: 'get',
        data: data
    })
}


